import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { withRouter } from 'react-router-dom';
import Footer from '../../components/Footer';
import 'wicg-inert';
import ScrollToTop from "../../libs/scrollToTop";
import { useKonami } from 'react-konami-code';
import Nav from '../../components/Nav.js';
import SecondaryNav from '../../components/SecondaryNav';

import ModalOverlay from "../../components/ModalOverlay";

import heroMobileImage from '../../images/articles/PO0131005_WF_BRAND_2HFY24_ISF_NovUpdate15_LP_767x577.jpg';
import heroDesktopImage from '../../images/articles/PO0131005_WF_BRAND_2HFY24_ISF_NovUpdate15_LP_1164x584.jpg';

import { fireTag } from '../../libs/analytics.js';

const BrightenCity = ({
    handleEvent,
    closeExitOverlay,
    addExitClickListeners,
    modalOverlay,
}) => {

    const [enableScrollGA, setEnableScrollGA] = useState(false);
    const [shouldBeInert, setShouldBeInert] = useState(false);
    const [gridVisible, setGridVisible] = useState(false);
    const heroOGImage = 'PO0131005_WF_BRAND_2HFY24_ISF_NovUpdate15_LP_ogimage.jpg';

    const toggleInert = () => {
        setShouldBeInert(!shouldBeInert)
    }

    const linkDisclosures = () => {
		const bodyDisclosures = document.querySelectorAll('.body-disclosures');
		const footerDisclosures = document.querySelectorAll('.footer-disclosures');
		bodyDisclosures.forEach(elem => {
			elem.addEventListener('click', (e) => {
				e.preventDefault();
				let disclosureNumber = Number(e.target.innerHTML)
				let targetElement = footerDisclosures[disclosureNumber - 1];
				window.scrollTo({
					left: 0,
					top: targetElement.offsetTop,
					behavior: 'smooth'
				});
				window.setTimeout(() => {
					targetElement.focus();
				}, 1000);
			});
		});

		footerDisclosures.forEach(elem => {
			elem.addEventListener('click', (e) => {
				e.preventDefault();
				let disclosureNumber = Number(e.target.innerHTML)
				let targetElement = bodyDisclosures[disclosureNumber - 1];
				fireTag('A2',disclosureNumber);
				window.scrollTo({
					left: 0,
					top: targetElement.offsetTop,
					behavior: 'smooth'
				});
				window.setTimeout(() => {
					targetElement.focus();
				}, 1000);
			});
		});
	}

	useEffect(() => {
		linkDisclosures();
		addExitClickListeners();
	}, []); // empty array says only use this effect once

    let mastheadImage = window.innerWidth < 768 ? heroMobileImage : heroDesktopImage;

    return (
		<>
			<Helmet>
				<title>Sustainability bonds brighten city streets</title>
				<meta
					name="description"
					content="Washington, D.C., and Philadelphia invest in sustainability and safety with LED streetlight projects."
				/>
				<meta property="og:title" content="Sustainability bonds brighten city streets"/>
				<meta
					property="og:description"
					content="Washington, D.C., and Philadelphia invest in sustainability and safety with LED streetlight projects."
				/>
				<meta property="og:image" content={`https://welcome.wf.com/impact/images/articles/${heroOGImage}`}/>

				<meta property="twitter:title" content="Sustainability bonds brighten city streets"/>
				<meta
					property="twitter:description"
					content="Washington, D.C., and Philadelphia invest in sustainability and safety with LED streetlight projects."
				/>
				i
			</Helmet>
			{/*TODO: isMobile should be passed in from route, not calc'd here */}

			<Nav handleEvent={handleEvent} isNotHomePage={false} activePage="articles" isMobile={window.innerWidth < 768} showExternalNav toggleInert={toggleInert} shouldBeInert={shouldBeInert}/>

			{!window.innerWidth < 768 && (
				<SecondaryNav page="Articles" shouldBeInert={shouldBeInert} activePage="articles"/>
			)}


			<main className="flex-container">

				<div className="flex-row">
					<div className="flex-col-sm-12 flex-col-md-8 text-center headline">
						<h1 id="articles-main-h1" style={{marginBottom: 10}}>
                        Sustainability bonds brighten city streets                         
                        </h1>
						<h2 className="summary">
                        Washington, D.C., and Philadelphia invest in sustainability and safety with LED streetlight projects.
                        </h2>
					</div>

				</div>

				<div className="flex-row full-width-md">
					<div className="flex-col-lg-10 flex-col-md-10 text-center hero-container">
						<img src={mastheadImage} alt="Three friends take a selfie on a city street."/>
					</div>
				</div>
                
				<div className="flex-row">
					<div className="flex-col-md-8 flex-col-sm-12 text-center article-intro info-graphic">
                    <div className="by-line">
							<p>By Richard Jordan, <span>sustainable finance content lead at Wells Fargo</span></p>
						</div>
						<div className="article-info">
							<div>
								<p>November 14, 2024</p>
							</div>
							<div>
								<p>4-minute read</p>
							</div>
						</div>
						<p>Changing streetlight lightbulbs can have meaningful impacts for urban communities. The <a onClick={()=> fireTag('A1','department of energy')} target="_blank" href="https://eta-publications.lbl.gov/sites/default/files/regulatory_issues_and_approaches_to_municipal_led_street_lighting_conversions.pdf" rel="noreferrer">Department of Energy</a> (DOE) finds U.S. cities can lower energy demands to reduce greenhouse gas emissions, improve public safety, and enhance the quality of life for their residents by making the shift toward LED, or light-emitting diodes, along streets and roadways.</p>
                        <p>
                        The improvement is catching on. A 2020 <a onClick={()=> fireTag('A1','doe report')} target="_blank" href="https://www.energy.gov/sites/default/files/2020/09/f78/ssl-led-adoption-aug2020.pdf" rel="noreferrer">DOE report</a> finds streetlights went from 28% LED to nearly 49% between 2016 and 2018 — a financially practical decision as streetlights can constitute <a onClick={()=> fireTag('A1','as much as 40%')} target="_blank" href="https://eta-publications.lbl.gov/sites/default/files/regulatory_issues_and_approaches_to_municipal_led_street_lighting_conversions.pdf" rel="noreferrer">as much as 40%</a> of municipal energy bills. There are many other <a onClick={()=> fireTag('A1','strategic advantages')} target="_blank" href="https://www.energy.gov/sites/default/files/2020/09/f78/ssl-led-adoption-aug2020.pdf" rel="noreferrer">strategic advantages</a> of incorporating LEDs in urban developments, including better energy efficiency and durability. 
                        </p>
                        <p>
                        LEDs can reduce streetlight energy use by <a onClick={()=> fireTag('A1','as much as 70%')} target="_blank" href="https://climatesmart.ny.gov/actions-certification/actions/?cHash=76e0b9dc3159b578d21ae6b5e9e1a727&tx_sjcert_action%5BactionObject%5D=26&tx_sjcert_action%5Baction%5D=getPDF&tx_sjcert_action%5Bcontroller%5D=Action&type=1336777436" rel="noreferrer">as much as 70%</a> and typically exceed 50,000 hours, more than three times the lifespan of most high-intensity discharge systems. The longer duration reduces the costs and frequency of replacements and maintenance.
                        </p>
					</div>
				</div>
                <div className="flex-row full-width">
					<div className="flex-row text-center">
						<div className="flex-col-md-8 flex-col-sm-12 text-center content-box">
							<div className="content-header bulleted">
								<h2 className="content-title bulleted">Key benefits of LED streetlights</h2>
							</div>
							<div className="inner-content bulleted">
								<div className="content">
									<div>
										<ul>
											<li className="offset-title">Environmental impact: The <a onClick={()=> fireTag('A1','department of energy')} target="_blank" href="https://eta-publications.lbl.gov/sites/default/files/regulatory_issues_and_approaches_to_municipal_led_street_lighting_conversions.pdf" rel="noreferrer">Department of Energy</a> found LED streetlights contribute to reduced greenhouse gas emissions by using less energy.</li>
											<li className="offset-title">Cost savings: LED streetlights can <a onClick={()=> fireTag('A1','save local governments')} target="_blank" href="https://pinellas.gov/story/county-saves-thousands-by-converting-to-led-streetlights/" rel="noreferrer">save local governments</a> in annual electricity costs.</li>
											<li className="offset-title">Crime reduction: An analysis found LED fixtures can lead to <a onClick={()=> fireTag('A1','reduced nighttime crime')} target="_blank" href="https://newarkcollaborative.org/highefficiency-led-lighting" rel="noreferrer">reduced nighttime crime</a>, such as aggravated assaults and robberies.</li>
                                            <li className="offset-title">Road safety: LED lights can <a onClick={()=> fireTag('A1','improve visibility')} target="_blank" href="https://www.energy.gov/eere/ssl/roadway-lighting-research" rel="noreferrer">improve visibility</a>, making it easier for drivers and pedestrians to identify objects at night.</li>
                                        </ul>
									</div>
								</div>

							</div>
						</div>
					</div>
				</div>
                <div className="flex-row">
					<div className="flex-col-md-8 flex-col-sm-12 text-center">
						<h2 className="subhead">
                        The nation’s capital inaugurates new streetlights                         
                        </h2>
                        <p>
                        Washington, D.C., is <a onClick={()=> fireTag('A1','modernizing')} target="_blank" href="https://streetlights.dc.gov/" rel="noreferrer">modernizing</a> approximately 75,000 street and alley lights with energy-efficient LED technology. The initiative with Plenary Infrastructure DC, which is projected to cut energy use for streetlights in half, was financed by a $159.7 million bond led by Wells Fargo in 2022 as the <a onClick={()=> fireTag('A1','first urban public-private partnerships')} target="_blank" href="https://www.fhwa.dot.gov/ipd/project_profiles/dc_street_light.aspx" rel="noreferrer">first urban Public-Private Partnerships</a> street lighting project in North America. 
                        </p>
                        <p>
                        The new streetlights are expected to eliminate 38,000 metric tons of greenhouse gas emissions annually, provide directional light to reduce light pollution, and add remote monitoring to detect outages instantly. The remote monitoring and control system will allow D.C. officials to customize the brightness of lights, and the LED fixtures will have a <a onClick={()=> fireTag('A1','warrantied life')} target="_blank" href="https://streetlights.dc.gov/pages/faqs" rel="noreferrer">warrantied life</a> of 10 years of performance with an expected life of over 20 years.  
                        </p>
                        <h2 className="subhead">
                        The City of Brotherly Love plans for a brighter future                        
                        </h2>
                        <p>
                        Philadelphia is also making significant strides in LED street lighting. In 2023, Wells Fargo was the senior manager for an approximately $83.5 million sustainability bond from the Philadelphia Energy Authority. The bond provides funding for a citywide conversion of 130,000 public streetlights to high-efficiency LEDs for roadways, alleys, and decorative lighting and a smart lighting management system with remote monitoring capabilities on a secure wireless network.  
                        </p>
                        <p>
                        The <a onClick={()=> fireTag('A1','philadelphia streetlight improvement project')} target="_blank" href="https://www.phillystreetlightimprovement.com/" rel="noreferrer">Philadelphia Streetlight Improvement Project</a>, which is expected to pay for itself, is the city’s largest-ever energy conservation project. It’s estimated to reduce the energy used for street lighting by 50% and cut the city's overall carbon emissions by more than 9%. It will also prioritize city neighborhoods with the highest public safety needs. 
                        </p>
                        <p>
                        “LED streetlights will enhance the quality of life for all Philadelphians by providing better, more reliable lighting,” said Philadelphia Mayor Jim Kenney. “It will also help us advance toward our city's goals for Vision Zero, by providing better visibility to reduce traffic crashes, as well as ensure our continued progress toward meeting our 2030 energy and climate goals.” 
                        </p>
                        <p>
                        The LED streetlight projects in Washington and Philadelphia demonstrate how energy-efficient lighting solutions can enhance sustainability and public services. These initiatives are emerging as a meaningful step to build safer, more vibrant, and environmentally conscious communities.
                        </p>
					</div>
				</div>
			</main>


			<Footer id="footer" footerStyles="global" shouldBeInert={shouldBeInert} activePage="sustainability" enableScrollGA={enableScrollGA}/>

			{modalOverlay && modalOverlay.open && (
				<ModalOverlay closeExitOverlay={closeExitOverlay} modalOverlay={modalOverlay}/>
			)}
		</>
    );

};

export default withRouter(BrightenCity);



